import React from "react"
import PropTypes from 'prop-types'

import SelectMultiGenericNew from "../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldRating_MultiselectValueNotEmpty from "../components/multiselect/value-not-empty"
import FieldRating_MultiselectPopoverOption from "../components/multiselect/popover-option"

const debug = false
// const debug = "RatingTriggerForm"

export default class FieldRating_AutomationTriggerForm extends React.Component<any,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:any) {
        super(props)

        this.state = {
            fromValue       : _.get(props.config, 'fromValue', null),
            toValue         : _.get(props.config, 'toValue', null)
        }
    }

    onChangeFromValues = (fromValue:any) => {
        this.setState({
            fromValue
        }, ()=>{
            this.props.onChangeCallback({fromValue})
        })
    }

    onChangeToValues = (toValue:any) => {
        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <div className="flex-row-left-top">
                <div className="label">from</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {this.props.field.getAutomationOptions()}
                                       values                           = {this.state.fromValue}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {(props:any)=><FieldRating_MultiselectValueNotEmpty scale={this.props.field.scale} {...props}/>}
                                       popoverOptionComponent           = {(props:any)=><FieldRating_MultiselectPopoverOption scale={this.props.field.scale} {...props}/>}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeFromValues}/>

                <div className="label">to</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {this.props.field.getAutomationOptions()}
                                       values                           = {this.state.toValue}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {(props:any)=><FieldRating_MultiselectValueNotEmpty scale={this.props.field.scale} {...props}/>}
                                       popoverOptionComponent           = {(props:any)=><FieldRating_MultiselectPopoverOption scale={this.props.field.scale} {...props}/>}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeToValues}/>
            </div>
        )
    }
}